// extracted by mini-css-extract-plugin
export default {"root":"XEl8tMW6kp","addNewRowSection":"IOMQSxMFgk","addNewRowSection_active":"vr5qITItiN"};